import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { PageLink, PageTitle } from '../../../_uLearn/layout/core';
import Teachers from './teachers';
import TeacherProfile from './teacher-profile';
const profileBreadCrumbs: Array<PageLink> = [
  {
    title: 'Teacher',
    path: 'Teacher',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];
const index = () => (
  <Routes>
    <Route
      element={
        <>
          <Outlet />
        </>
      }
    >
      <Route
        path="*"
        element={<Navigate to="/error/404" />}
      />
      <Route
        // path=""
        index
        element={
          <>
            <PageTitle breadcrumbs={profileBreadCrumbs}>Teacher</PageTitle>
            <Teachers />
          </>
        }
      />
      <Route
        path="/view-teacher"
        element={
          <>
            <PageTitle breadcrumbs={profileBreadCrumbs}>View Teacher</PageTitle>
            <TeacherProfile />
          </>
        }
      />
    </Route>
  </Routes>
);
export default index;
